/**
 * Color palette utility for charts
 * Provides consistent colors across all charts with rotation support for many items
 */

// Primary color palette (from designer)
const PRIMARY_COLORS = [
  '#53B1FD', // Blue
  '#6172F3', // Purple
  '#F4B857', // Yellow
  '#F38744', // Orange
  '#13B57D', // Green
];

// Secondary color palette
const SECONDARY_COLORS = [
  '#2E90FA', // Blue
  '#7A5AF8', // Purple
  '#F1A62D', // Yellow
  '#EF6820', // Orange
  '#18B081', // Green
];

// Extended palette for many items
const EXTENDED_COLORS = [
  '#10B981', // Green (status)
  '#F59E0B', // Amber (status)
  '#EF4444', // Red (status)
  '#3B82F6', // Blue
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#14B8A6', // Teal
  '#F97316', // Orange
  '#84CC16', // Lime
  '#06B6D4', // Cyan
];

/**
 * Get color for a specific index with rotation
 */
export function getColorForIndex(index: number): string {
  const allColors = [...PRIMARY_COLORS, ...SECONDARY_COLORS, ...EXTENDED_COLORS];
  return allColors[index % allColors.length];
}

/**
 * Get color palette for a specific count
 */
export function getColorPalette(count: number): string[] {
  const allColors = [...PRIMARY_COLORS, ...SECONDARY_COLORS, ...EXTENDED_COLORS];
  const result: string[] = [];
  
  for (let i = 0; i < count; i++) {
    result.push(allColors[i % allColors.length]);
  }
  
  return result;
}

/**
 * Get status colors for specific use cases
 */
export const STATUS_COLORS = {
  green: '#10B981',
  amber: '#F59E0B',
  red: '#EF4444',
  blue: '#2E90FA',
};
